var youbora = require('youboralib')
var manifest = require('../../manifest.json')

var GenericAdsAdapter = youbora.Adapter.extend({
  getVersion: function () {
    return manifest.version + '-jwplayer-ads'
  },

  getDuration: function () {
    return this.duration
  },

  getResource: function () {
    return this.resource
  },

  getPlayhead: function () {
    return this.playhead
  },

  getTitle: function () {
    return this.title
  },

  getPosition: function () {
    if (this.plugin.getAdapter() && !this.plugin.getAdapter().flags.isJoined) {
      return 'pre'
    } else if (this.position === 'pre' || this.position === 'mid' || this.position === 'post') {
      return this.position
    }
    return 'mid'
  },

  registerListeners: function () {
    // Register listeners
    // Enable playhead monitor (buffer = true, seek = false)
    this.monitorPlayhead(true, false, 1200)

    // Register listeners
    this.references = []
    this.references['adTime'] = this.adTimeListener.bind(this)
    this.references['adStarted'] = this.adStartedListener.bind(this)
    this.references['adImpression'] = this.adImpressionListener.bind(this)
    this.references['adPause'] = this.adPauseListener.bind(this)
    this.references['adPlay'] = this.adPlayListener.bind(this)
    this.references['adSkipped'] = this.adSkippedListener.bind(this)
    this.references['adComplete'] = this.adCompleteListener.bind(this)
    this.references['adClick'] = this.adClickListener.bind(this)
    this.references['adError'] = this.adErrorListener.bind(this)

    for (var key in this.references) {
      this.player.on(key, this.references[key])
    }
  },

  /** Unregister listeners to this.player. */
  unregisterListeners: function () {
    // Disable playhead monitoring
    if (this.monitor) this.monitor.stop()

    // unregister listeners
    if (this.player && this.references) {
      for (var key in this.references) {
        this.player.off(key, this.references[key])
      }
      this.references = []
    }
  },

  adTimeListener: function (e) {
    this.playhead = e.position
    this.duration = e.duration
    if (this.plugin._adapter) this.plugin._adapter.firePause()
    this.fireStart()
    this.fireJoin()
  },

  adStartedListener: function (e) {
    this.position = e.adposition
    this.resource = e.tag
    this.title = e.adtitle
  },

  adImpressionListener: function (e) {
    this.position = e.adposition
    this.resource = e.tag
    this.title = e.adtitle
  },

  adPauseListener: function (e) {
    this.firePause()
  },

  adPlayListener: function (e) {
    this.fireResume()
  },

  adSkippedListener: function (e) {
    this.fireStop({ skipped: true })
    if (this.plugin._adapter) this.plugin._adapter.fireResume()
  },

  adCompleteListener: function (e) {
    this.fireStop()
    if (this.plugin._adapter) this.plugin._adapter.fireResume()
    this.resetValues()
  },

  adClickListener: function (e) {
    this.fireClick() // e.tag is the link clicked
  },

  adErrorListener: function (e) {
    this.fireError(e.message)
  },

  resetValues: function () {
    this.playhead = undefined
    this.duration = undefined
    this.position = undefined
    this.resource = undefined
    this.title = undefined
  }

})

module.exports = GenericAdsAdapter
